var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-link p-0 mr-3",attrs:{"title":"Export Customer Data"},on:{"click":function($event){return _vm.exportCustomer()}}},[_c('i',{staticClass:"fas fa-file-export fa-lg"})])}
var staticRenderFns = []

export { render, staticRenderFns }